import { styled } from '@mui/material'

import { theme } from 'styles/theme'

export const CardsContainer = styled('div')(() => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '16px',
  width: '100%',
  marginTop: '16px',

  [theme.breakpoints.down(768)]: {
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '12px'
  },

  [theme.breakpoints.down(560)]: {
    gridTemplateColumns: '1fr',
    gap: '12px'
  }
}))

type CardWrapperProps = {
  isPercentage?: boolean
}

export const CardWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isPercentage'
})<CardWrapperProps>(({ isPercentage }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
  padding: '20px',
  borderRadius: '12px',
  border: `1px solid ${theme.palette.neutral[700]}`,
  backgroundColor: theme.palette.neutral[900],
  transition: 'all 0.2s ease-in-out',
  minHeight: '100px',

  '&:hover': {
    borderColor: theme.palette.neutral[600],
    backgroundColor: theme.palette.neutral[850] || theme.palette.neutral[800]
  },

  ...(isPercentage && {
    background: `linear-gradient(135deg, ${theme.palette.neutral[900]} 0%, ${
      theme.palette.primary[900] || theme.palette.neutral[850]
    } 100%)`,
    borderColor: theme.palette.primary[700] || theme.palette.neutral[600]
  }),

  [theme.breakpoints.down(768)]: {
    padding: '16px',
    minHeight: '90px'
  },

  [theme.breakpoints.down(560)]: {
    padding: '16px',
    minHeight: 'auto'
  }
}))

export const CardHeader = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '8px'
}))

export const CardTitle = styled('span')(() => ({
  fontSize: '13px',
  fontWeight: 500,
  color: theme.palette.neutral[400],
  lineHeight: 1.4
}))

export const CardValue = styled('span')(() => ({
  fontSize: '28px',
  fontWeight: 600,
  color: theme.palette.neutral[100],
  lineHeight: 1.2,

  [theme.breakpoints.down(768)]: {
    fontSize: '24px'
  }
}))

// Keeping for backwards compatibility if needed
